(() => {
  const init = (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const cards = [...root.querySelectorAll('[data-nc-card]')];
    const grid = root.querySelector('.nc-grid');
    const type = root.querySelector('[data-nc-type]');
    const strength = root.querySelector('[data-nc-strength]');
    const area = root.querySelector('[data-nc-area]');
    const sort = root.querySelector('[data-nc-sort]');
    const chips = [...root.querySelectorAll('[data-nc-choice]')];
    const apply = () => {
      let count = 0;
      cards.forEach(card => {
        const matches = (type.value === 'all' || card.dataset.type === type.value) && (strength.value === 'all' || card.dataset.strength === strength.value) && (area.value === 'all' || Number(card.dataset.area) === Number(area.value));
        card.hidden = !matches;
        if (matches) count++;
      });
      const ordered = [...cards].sort((a, b) => {
        if (sort.value === 'price-asc') return Number(a.dataset.price) - Number(b.dataset.price);
        if (sort.value === 'price-desc') return Number(b.dataset.price) - Number(a.dataset.price);
        if (sort.value === 'name') return a.dataset.name.localeCompare(b.dataset.name, 'de', {numeric:true});
        return Number(a.dataset.order) - Number(b.dataset.order);
      });
      ordered.forEach(card => grid.append(card));
      root.querySelector('[data-nc-count]').textContent = count;
      root.querySelector('.nc-empty').hidden = count > 0;
      chips.forEach(chip => {
        const value = chip.dataset.ncChoice;
        const active = area.value === 'all' && ((value === 'all' && type.value === 'all' && strength.value === 'all') || (value === type.value && strength.value === 'all') || (value === strength.value && type.value === 'rolls'));
        chip.setAttribute('aria-pressed', String(active));
      });
    };
    [type, strength, area, sort].forEach(el => el.addEventListener('change', () => {
      if (el === strength && strength.value !== 'all') type.value = 'rolls';
      if (el === type && type.value !== 'rolls') { strength.value = 'all'; area.value = 'all'; }
      if (el === area && area.value !== 'all') type.value = 'rolls';
      apply();
    }));
    chips.forEach(chip => chip.addEventListener('click', () => {
      const value = chip.dataset.ncChoice;
      area.value = 'all';
      strength.value = /^\d+$/.test(value) ? value : 'all';
      type.value = /^\d+$/.test(value) ? 'rolls' : value;
      apply();
    }));
    root.querySelectorAll('[data-nc-reset]').forEach(button => button.addEventListener('click', () => {type.value = 'all'; strength.value = 'all'; area.value = 'all'; apply();}));
    const rail = root.querySelector('.nc-chips');
    root.querySelectorAll('[data-nc-scroll]').forEach(button => button.addEventListener('click', () => rail.scrollBy({left:Number(button.dataset.ncScroll) * rail.clientWidth * .65, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'})));
    const filter = root.querySelector('.nc-filters');
    filter.open = matchMedia('(min-width: 990px)').matches;
    const moreButton = root.querySelector('[data-nc-more-toggle]');
    const moreContent = root.querySelector('#nc-more-content');
    if (moreButton && moreContent) {
      moreButton.hidden = false;
      moreContent.querySelector('summary').hidden = true;
      moreButton.addEventListener('click', () => {
        moreContent.open = !moreContent.open;
        moreButton.setAttribute('aria-expanded', String(moreContent.open));
        moreButton.querySelector('span').textContent = moreContent.open ? '−' : '+';
      });
    }
    apply();
  };
  document.querySelectorAll('[data-nomads-collection]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-nomads-collection]').forEach(init));
})();

